"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIconButtonStyling = void 0;
var react_1 = require("@emotion/react");
var makeIconButtonStyling = function (variant) {
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)({
        height: '100%',
        cursor: 'pointer',
        boxShadow: 'none',
        '& .MuiButton-startIcon': {
            margin: 0,
        },
        '&.MuiButton-root': __assign(__assign({ minWidth: '100%', color: theme.mvf.palette.text.primaryTextColor, '&.Mui-disabled': {
                color: theme.mvf.palette.status.disabled,
            } }, (variant === 'inline' && {
            backgroundColor: theme.mvf.palette.component.backButtonColor,
        })), (variant === 'stacked' && {
            backgroundColor: 'rgb(251, 251, 251)',
            border: 'solid',
            borderWidth: theme.mvf.border.width.thin,
            borderColor: 'rgb(225, 225, 225)',
        })),
        '@media (hover: hover)': {
            '&:hover': __assign(__assign({ boxShadow: theme.mvf.boxShadow.heavy }, (variant === 'inline' && {
                backgroundColor: theme.mvf.palette.component.backButtonHoverColor,
            })), (variant === 'stacked' && {
                backgroundColor: 'rgb(237, 237, 237)',
            })),
        },
    });
};
exports.makeIconButtonStyling = makeIconButtonStyling;
exports.default = exports.makeIconButtonStyling;
//# sourceMappingURL=makeIconButtonStyling.js.map